import React, { useState } from 'react';
import { useApiEffect } from 'framework/hooks/useApiEffect';
import {
	IInventoryItemsQueryParamsForStockMovement,
	inventoryItemsQuery_queryForStockMovement,
	IProductCatalogQueryParamsForStockMovement,
	productCatalogQuery_queryForStockMovement,
} from 'gen/ApiClient';
import { DefaultInventoryItemsQueryParamsForStockMovement } from 'shared/searchAndSelect/DefaultInventoryItemsQueryParamsForStockMovement';
import { SearchContext } from './SearchContext';

const DefaultPcParams: IProductCatalogQueryParamsForStockMovement = {
	searchString: '',
	sortParams: { direction: 'desc', property: 'created' },
	pageParams: { index: 1, size: 10 },
	types: [],
	categories: [],
	subcategories: [],
};

interface IProps {
	children: any;
}

export const SearchProvider = ({ children }: IProps) => {
	const [pcParams, setPcParams] = useState<IProductCatalogQueryParamsForStockMovement>(DefaultPcParams);
	const [pcQueryResult] = useApiEffect(productCatalogQuery_queryForStockMovement, pcParams);
	const [iiParams, setIIParams] = useState<IInventoryItemsQueryParamsForStockMovement>(DefaultInventoryItemsQueryParamsForStockMovement);
	const [iiQueryResult] = useApiEffect(inventoryItemsQuery_queryForStockMovement, iiParams);

	return (
		<SearchContext.Provider
			value={{
				pcParams: pcParams,
				pcQueryResult: pcQueryResult,
				setPcParams: setPcParams,
				iiParams: iiParams,
				iiQueryResult: iiQueryResult,
				setIIParams: setIIParams,
			}}>
			{children}
		</SearchContext.Provider>
	);
};
